export default __webpack_public_path__ + "static/media/img_5_thumb.354f4022.JPG";